import { FunctionComponent } from 'react'

import { useStyles } from './useStyles'

export type PasswordStrength = 'weak' | 'medium' | 'strong'

interface PasswordStrengthBarProps {
  strength?: PasswordStrength
  message?: string
}

const PASSWORD_STRENGTH = {
  weak: 'fraca',
  medium: 'mediana',
  strong: 'forte',
}

const PasswordStrengthBar: FunctionComponent<PasswordStrengthBarProps> = ({
  strength,
  message,
}) => {
  const { indicators, tip } = useStyles()

  const weakClass = () => {
    return strength === 'weak' ? 'password-strength__indicator--weak' : ''
  }

  const mediumClass = () => {
    return strength === 'medium' ? 'password-strength__indicator--medium' : ''
  }

  const strongClass = () => {
    return strength === 'strong' ? 'password-strength__indicator--strong' : ''
  }

  return (
    <div className="password-strength__root">
      <div
        className="password-strength__indicators"
        css={indicators}
        aria-label={
          strength
            ? `Sua senha é ${PASSWORD_STRENGTH[strength]}`
            : 'Força da sua senha'
        }
      >
        <span
          className={`password-strength__indicator ${weakClass()}${mediumClass()}${strongClass()}`}
          aria-hidden="true"
        ></span>
        <span
          className={`password-strength__indicator ${mediumClass()}${strongClass()}`}
          aria-hidden="true"
        ></span>
        <span
          className={`password-strength__indicator ${strongClass()}`}
          aria-hidden="true"
        ></span>
      </div>
      {strength && message && (
        <span
          css={tip}
          className={`password-strength__tip ${
            strength && `password-strength__tip--${strength}`
          }`}
        >
          {message}
        </span>
      )}
    </div>
  )
}

export { PasswordStrengthBar }
